import { NgForm } from '@angular/forms';
import * as _ from 'lodash';
import { CONFIG } from '../../../core/config';
import { FormControlBase } from './form-control-base';
import { FormControlData } from './form-control-data';

export class FilterDropdownControl extends FormControlBase<string> {
  public overrideFilterDropdown;
  controlType = 'filter-dropdown';

  constructor(options: FormControlData<string> = {}, form: NgForm = null) {
    super(options, form);
  }

  protected initialize() {
    const modelValue = _.get(this.model, this.propertyName);

    if (this.required && modelValue === CONFIG.constants.emptyGuid) {
      this.value = null;
    } else {
      this.value = modelValue;
    }
  }

  protected setValue(value: string) {
    if (this.required && value === CONFIG.constants.emptyGuid) {
      value = null;
    }

    super.setValue(value);
  }

  commit() {
    if (this.value === '') {
      _.set(this.model, this.propertyName, undefined);
    } else {
      _.set(this.model, this.propertyName, this.value);
    }
  }
}
